export const countryConfig = {
  GB: { currency: "GBP", symbol: "£", lang: "en" },
  US: { currency: "USD", symbol: "$", lang: "en" },
  ES: { currency: "EUR", symbol: "€", lang: "es" },
  DEFAULT: { currency: "GBP", symbol: "£", lang: "en" },
};

export const conversionRates = {
  GBP: { GBP: 1, USD: 1.27, EUR: 1.1559 },
  USD: { GBP: 0.79, USD: 1, EUR: 0.91 },
  EUR: { GBP: 0.87, USD: 1.1, EUR: 1 },
};

export async function getLiveRate(from = "GBP", to = "EUR") {
  try {
    const res = await fetch(
      `https://api.exchangerate.host/convert?from=${from}&to=${to}`
    );
    const data = await res.json();
    if (data?.info?.rate) return data.info.rate;
  } catch (err) {
    console.error("Live rate fetch failed, using fallback", err);
  }
  return conversionRates[from]?.[to] || 1;
}

export function getConfigByCountryCode(countryCode = "GB") {
  const code = countryCode?.toUpperCase();
  return countryConfig[code] || countryConfig.DEFAULT;
}

export function convertPrice(amount, fromCurrency = "GBP", toCurrency = "GBP") {
  const rate = conversionRates[fromCurrency]?.[toCurrency] || 1;
  return Number((amount * rate).toFixed(2));
}

export function formatCurrency(amount, countryCode = "GB") {
  const { symbol, lang } = getConfigByCountryCode(countryCode);

  const num = Number(amount) || 0;

  const formattedNumber = new Intl.NumberFormat(lang, {
    minimumFractionDigits: num % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  })
    .format(num)
    .replace(",", ".");

  return `${symbol}${formattedNumber}`;
}
